import moment from 'moment-timezone'
import 'moment/locale/es'
import 'moment/locale/fr-ca'
import 'moment/locale/ja'
import 'moment/locale/nl'
import 'moment/locale/sv'

// Importing a locale package registers it *and* switches moment's global
// locale to that package (last import wins — currently Swedish). Pin English
// back as the global default so Daily / clinician views that call
// moment().format('MMM DD, YYYY') keep capitalised English months.
moment.locale('en')

// Maps StrivePD report locale codes onto moment locale ids. moment's `es` is
// peninsular Spanish, so es_ES maps there too. English is moment's default and
// does not need an explicit locale import.
const MOMENT_LOCALES = {
  en: 'en',
  es: 'es',
  es_ES: 'es',
  fr_CA: 'fr-ca',
  ja: 'ja',
  nl: 'nl',
  sv: 'sv',
}

// Format a report date using the active locale without mutating moment's global
// locale. LL/ll are locale-aware tokens, so both the month name and field order
// follow the locale (e.g. "August 4, 2026" vs "4 augustus 2026").
export const formatReportDate = ({ date, locale, short = false }) =>
  moment(date)
    .locale(MOMENT_LOCALES[locale] ?? 'en')
    .format(short ? 'll' : 'LL')
